<template>
  <SimpleField
    :disabled="disabled"
    mode="Decimal"
    :operators="operators"
    :value.sync="mutableValue"/>
</template>
<script>
import SimpleField from 'components/automation/conditions/default/simpleField.vue'

/**
 * 9
 */
export default {
  name: 'tenderBudget',
  computed: {
    mutableValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  components: {
    SimpleField
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
